import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Grid } from "@material-ui/core";
import { FactorMeta } from "../../types";
import { FactorCard } from "../../../../components/reputation/FactorCard";

export const GeneralFactorsTable: React.FC<{
  factors: Record<string, FactorMeta>;
}> = ({ factors }) => (
    <Grid container spacing={2}>
      {Object.entries(factors).map(([key, meta]) => (
        <Grid item xs={12} md={6} lg={4} key={key}>
          <FactorCard name={key} meta={meta} />
        </Grid>
      ))}
    </Grid>
 /*  <TableContainer component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Factor</TableCell>
          <TableCell>Description</TableCell>
          <TableCell>Min</TableCell>
          <TableCell>Max</TableCell>
          <TableCell>Weightage</TableCell>
          <TableCell>Formula</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {Object.entries(factors).map(([key, meta]) => (
          <TableRow key={key}>
            <TableCell>{key.replace(/_/g, ' ')}</TableCell>
            <TableCell>{meta.description}</TableCell>
            <TableCell>{meta.min_value}</TableCell>
            <TableCell>{meta.max_value}</TableCell>
            <TableCell>{meta.weightage}</TableCell>
            <TableCell>{meta.formula}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer> */
);
